import * as Joi from 'joi';

const searchTransactionLogSchema = Joi.object({
  startDate: Joi.string().required().messages({
    'date.base': 'Start Date not allowed to be empty.',
    'date.max': 'Start Date should not be greater than current date.',
    'any.required': 'Start Date not allowed to be empty.',
  }),
  endDate: Joi.string().required().messages({
    'date.base': 'End Date not allowed to be empty.',
    'date.max': 'End Date should not be greater than current date.',
    'any.required': 'End Date not allowed to be empty.',
  }),
});

export default searchTransactionLogSchema;
